import Cookies from "universal-cookie";
import {CreateWidgetIcon}  from './CreateWidgetIcon';
import {CreatedWidgetsIcon} from './CreatedWidgetsIcon';
import {CreateSenderIcon} from './CreateSenderIcon';
import {CreatedSendersIcon} from './CreatedSendersIcon';
import {BalanceIcon} from './BalanceIcon';
import {ExitIcon} from './ExitIcon';
import {SupportIcon} from './SupportIcon';
import RightArrowIcon from './RightArrowIcon';

function Menu(props) {
  return (
    <div className='fullPage_leftMenu_menu'>
        <ul>
            <a   href='/createwidget' >
              <li className={props.page == 'createwidget' ? "selectedMenuItem icon1 icon":"icon1 icon"}>  
                <CreateWidgetIcon/> 
                <span className="menuItemText firstMenuItemText">
                  Создать чат-бот <span className="bluePlus">+</span> виджет
                  </span>
                  
                  <RightArrowIcon />
                  
              </li>
            </a>

    
            <a href='/widgets' >
              <li className={props.page == 'widgets' ? "selectedMenuItem icon2 icon":"icon2 icon"}>
                <CreatedWidgetsIcon />
                <span  className="menuItemText secondMenuItemText">
                Созданные виджеты 
                </span>
                <RightArrowIcon />
              </li>
            </a>

            
            <a   href='/sender' >
              <li className={props.page == 'sender' ? "selectedMenuItem icon3 icon":"icon3 icon"}>  
                <CreateSenderIcon />  
                <span className="menuItemText thirdMenuItemText">
                Создать рассылку <span className="bluePlus">+</span>
                </span>
                <RightArrowIcon />
              </li>
            </a>

            <a   href='/mailing' >
              <li className={props.page == 'mailing' ? "selectedMenuItem icon4 icon":"icon4 icon"}>   
                <CreatedSendersIcon />
                <span className="menuItemText fourthMenuItemText">
                Созданные рассылки
                </span>
                <RightArrowIcon />
              </li>
            </a>
           
            <a href='/balance' >
              <li className={props.page == 'balance' ? "selectedMenuItem icon5 icon":"icon5 icon"}>  
                <BalanceIcon />
                <span className="menuItemText fifthMenuItemText">
                  Оплата
                </span>
                <RightArrowIcon />
              </li>
            </a>
    
        </ul>

        <div class='border-bottom'>
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="117"
      height="1"
      fill="none"
      viewBox="0 0 117 1"
    >
      <path stroke="url(#paint0_linear_35_988)" d="M0 0.5L117 0.5"></path>
      <defs>
        <linearGradient
          id="paint0_linear_35_988"
          x1="-0.325"
          x2="117.101"
          y1="1"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0767F4"></stop>
          <stop offset="1" stopColor="#2AC3D1"></stop>
        </linearGradient>
      </defs>
    </svg>
   
            </div>

            <ul>
                <a href='https://t.me/arturcronberg' target="_blank" className="icon6 icon">
                  <li>
                    <SupportIcon />
                    <span className="menuItemText sixthMenuItemText">
                    Тех. поддержка
                      </span> 
                      <RightArrowIcon />
                  </li>
                </a>
                <li onClick={() => {
                  const cookies = new Cookies();
                  cookies.remove('tgsubs_token', {path : '/'})
                  window.location.href = '/auth'
                }} className='icon7 icon'>
               
                <ExitIcon/>
                <span className="menuItemText seventhMenuItemText">
                  Выход
                      </span>    
                </li> 
            </ul>
    </div>
         );
}

export default Menu;